import { useQuery } from "@tanstack/react-query";

import { getSoilSightNonCropDatabase } from "services";

import { useIsAuthenticated } from "utils";

import { GET_SOIL_SIGHT_NON_CROP_DATABASE } from "consts";

import { SoilSightNonCropDefaults } from "models";

// farm-level defaults from the KH-116 dataset
export const useGetSoilSightNonCropDatabase = () => {
  const isAuthenticated = useIsAuthenticated();

  return useQuery<SoilSightNonCropDefaults>({
    queryKey: [GET_SOIL_SIGHT_NON_CROP_DATABASE],
    queryFn: () => getSoilSightNonCropDatabase(),
    staleTime: 1000 * 60 * 30,
    enabled: isAuthenticated,
  });
};
